import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {ConnectedRouter} from 'react-router-redux';
import {Provider} from 'react-redux';
import App from './containers/App';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

// eslint-disable-next-line no-undef
const stripePublishableKey = (typeof WP_STRIPE_PL !== 'undefined' && WP_STRIPE_PL) ? WP_STRIPE_PL : '';
// Avoid calling loadStripe with an empty key to prevent runtime integration errors.
const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;

export default class Root extends Component {
  render() {
    const {store, history} = this.props;
    return (
      <Provider store={store}>
          <ConnectedRouter history={history}>
             <Elements stripe={stripePromise}>
                <App/>
             </Elements>
          </ConnectedRouter>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/Root.js